export const resources = [
    {
      name: "accounts",
      list: "/accounts",
      create: "/accounts/create",
      show: "/accounts/show/:id",
    },
    {
      name: "users",
      list: "/users",
      create: "/users/create",
      edit: "/users/edit/:id",
      show: "/users/show/:id",
    },
    {
      name: "user-groups",
      list: "/user-groups",
      create: "/user-groups/create",
      edit: "/user-groups/edit/:id",
    },
    {
      name: "products",
      list: "/products",
      create: "/products/create",
      edit: "/products/edit/:id",
      show: "/products/show/:id",
    },
    {
      name: "pricing-plans",
      list: "/pricing-plans",
      create: "/pricing-plans/create",
      edit: "/pricing-plans/edit/:id",
      show: "/pricing-plans/show/:id",
    },
    {
      name: "forms",
      list: "/forms",
      create: "/forms/create",
      edit: "/forms/edit/:id",
      show: "/forms/show/:id",
    },
    {
      name: "orders",
      list: "/orders",
      create: "/orders/create",
      edit: "/orders/edit/:id",
      show: "/orders/show/:id",
    },
    {
      name: "attachments",
      list: "/attachments",
      create: "/attachments/create",
      edit: "/attachments/edit/:id",
      show: "/attachments/show/:id",
    },
    {
      name: "messages",
      list: "/messages",
      create: "/messages/create",
      edit: "/messages/edit/:id",
      show: "/messages/show/:id",
    },
    {
      name: "payments",
      create: "/payments/create"
    },
    {
      name: "transactions",
      list: "/transactions",
      show: "/transactions/show/:id",
    },
    {
      name: "dashboard",
      list: "/dashboard",
    },
    {
      name: "tenants",
      list: "/tenants",
      create: "/tenants/create",
      edit: "/tenants/edit/:id",
      show: "/tenants/show/:id",
    },
    {
      name: "automation-tasks",
      list: "/automation-tasks",
    },
    {
      name: "service-providers",
      list: "/service-providers",
      create: "/service-providers/create",
      edit: "/service-providers/edit/:id",
      show: "/service-providers/show/:id",
    },
    {
      name: "assignment-rules",
      list: "/assignment-rules",
    },
    {
      name: "credit-packs",
      list: "/credit-packs",
    },
    {
      name: "tenant-billing-usage",
      list: "/usage",
    },
    {
      name: "clients",
      list: "/clients",
      create: "/clients/create",
      edit: "/clients/edit/:id",
      show: "/clients/show/:id",
    },
  ];